<template>
  <b-modal
    :id="id"
    :cancel-title="$t('Cancel')"
    :ok-title="$t('Delete')"
    :title="$t('Delete') + ' ' + theArticle + ' ' + $t(itemSingularName)"
    cancel-variant="primary"
    ok-variant="danger"
    @ok="handleOk">
    <div v-if="selectedItem !== null" class="mb-4">
      {{ $t('Delete') }} {{ theArticle }}{{ $t(itemSingularName) }} {{ itemToString }} ?
    </div>
  </b-modal>
</template>

<script>

import api from '../../services/api'

export default {

  name: 'ItemDeleteModal',

  props: {
    selectedItem: Object,
    selectedItemSpecialString: {
      type: String,
      default: null
    },
    controllerName: String,
    itemSingularName: String,
    itemSingularNameUpp: String,
    isFeminine: {
      type: Boolean,
      default: false
    },
    beginsWithVoyel: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: 'item-delete-modal'
    }
  },

  emits: ['didDeleteItem'],

  methods: {

    handleOk (bvModalEvt) {
      bvModalEvt.preventDefault() // Prevent modal from closing
      this.handleSubmit()
    },

    handleSubmit () {
      let successToastMessage = this.$i18n.t(this.itemSingularNameUpp) + this.itemToString + ' ' + this.$i18n.t(this.isFeminine ? 'f.deleted' : 'deleted')

      api
        .delete(`/${this.controllerName}/${this.selectedItem.id}`)
        .then(response => {
          this.$emit('didDeleteItem')
          this.hideModal()
          this.$nextTick(() => {
            this.successToast(successToastMessage)
          })
        })
        .catch((error) => {
          if (error.response.status === 404 || error.response.status === 401) {
            this.$bvToast.toast(this.$i18n.t(error.response.data.message), {
              title: this.$i18n.t('Error.title'),
              autoHideDelay: 4000,
              toaster: 'b-toaster-bottom-right',
              solid: true
            })
          }
        })
    },

    hideModal () {
      this.$bvModal.hide(this.id)
    },

    successToast (message) {
      this.$bvToast.toast(message, {
        autoHideDelay: 4000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: 'success',
        solid: true
      })
    }
  },

  computed: {

    itemToString () {
      return this.selectedItemSpecialString ? this.selectedItemSpecialString : " '" + this.selectedItem.tostring + "' "
    },

    theArticle () {
      return this.$i18n.t(this.beginsWithVoyel ? 'l.i' : (this.isFeminine ? 'l.e' : 'l'))
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/b122/ItemDeleteModal.vue